import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Token is kept in sessionStorage (cleared when the tab closes — smaller XSS
// window than localStorage) and sent as a Bearer header. The backend also sets
// an httpOnly cookie as defense-in-depth.
export const TOKEN_KEY = "dbd_token";
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
